import { path } from 'ramda';

import { authenticate } from '../../entrar/entrar-action';
import { setFacebookAvatar } from '../../api/customer/login';

import config from '../../generated/config';

const { facebookAppId } = config;

export const startFacebookSdk = () => {
  ((d, s, id) => {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = `//connect.facebook.net/pt_BR/sdk.js#xfbml=1&version=v2.10&appId=${facebookAppId}`;
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
};

export const getFacebookResponse = () => {
  return new Promise((resolve, reject) => {
    try {
      window.FB.login(
        response => {
          if (response.status !== 'connected') {
            reject(response);
          }

          resolve(response);
        },
        { scope: 'public_profile,email' }
      );
    } catch (error) {
      reject(error);
    }
  });
};

export const loginWithFacebook = async authenticationInfo => {
  try {
    const customer = await authenticate(authenticationInfo);
    setFacebookAvatar(path(['authResponse', 'userID'], authenticationInfo));
    return customer;
  } catch (error) {
    return Promise.reject(error);
  }
};

const notIsHttps = () => {
  try {
    return window.location.protocol !== 'https:';
  } catch (error) {
    return true;
  }
};

const SUCCESSFUL_LOGIN_WITH_FACEBOOK = 'SUCCESSFUL_LOGIN_WITH_FACEBOOK';
const HTTPS_REQUIRED = 'HTTPS_REQUIRED';

export const tryLoginWithFacebook = () => {
  return new Promise((resolve, reject) => {
    if (notIsHttps()) {
      return reject(HTTPS_REQUIRED);
    }

    getFacebookResponse()
      .then(loginWithFacebook)
      .then(result => resolve(SUCCESSFUL_LOGIN_WITH_FACEBOOK))
      .catch(error => reject(error));
  });
};
